import { useEffect, useRef } from "react";

export default function Starfield({ density = 0.00012, className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let stars = [];
    let raf;
    let t = 0;
    let scrollTarget = window.scrollY;
    let scrollSmooth = scrollTarget;

    const resize = () => {
      const rect = canvas.parentElement.getBoundingClientRect();
      canvas.width = rect.width;
      canvas.height = rect.height;
      const count = Math.floor(rect.width * rect.height * density);
      stars = Array.from({ length: count }, () => {
        const roll = Math.random();
        return {
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          r: Math.random() * 1.3 + 0.3,
          phase: Math.random() * Math.PI * 2,
          speed: 0.3 + Math.random() * 0.8,
          depth: 0.08 + Math.random() * 0.3,
          hue: roll < 0.12 ? "190,220,255" : roll < 0.22 ? "205,185,255" : "255,255,255",
        };
      });
    };

    const onScroll = () => {
      scrollTarget = window.scrollY;
    };

    resize();
    window.addEventListener("resize", resize);
    window.addEventListener("scroll", onScroll, { passive: true });

    const draw = () => {
      t += 0.016;
      scrollSmooth += (scrollTarget - scrollSmooth) * 0.05;
      const w = canvas.width;
      const h = canvas.height;
      ctx.clearRect(0, 0, w, h);
      for (const s of stars) {
        const a = 0.2 + 0.8 * Math.abs(Math.sin(t * s.speed + s.phase));
        const y = (((s.y - scrollSmooth * s.depth) % h) + h) % h;
        const x = (((s.x + t * s.depth * 4) % w) + w) % w;
        ctx.beginPath();
        ctx.arc(x, y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${s.hue},${a})`;
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("scroll", onScroll);
    };
  }, [density]);

  return (
    <canvas
      ref={ref}
      data-testid="starfield"
      className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
    />
  );
}
